import * as types from './types';
import { get } from 'lodash';
import { fetchPost } from '../api/fetch';
import * as loginActions from '../actions/loginActions';
import { openSnackBar } from './snackbarAction';

export function onPerformanceRecord(response) {
  return {
    type: types.PERFORMANCE_ANALYSIS,
    response,
  };
}
export function onTestResult(response) {
  return {
    type: types.TEST_RESULT,
    response,
  };
}
export function onTestAnalysis1(response) {
  return {
    type: types.TEST_ANALYSIS_PAPER_1,
    response,
  };
}
export function onTestAnalysis2(response) {
  return {
    type: types.TEST_ANALYSIS_PAPER_2,
    response,
  };
}
export function onTestSolution1(response) {
  return {
    type: types.TEST_SOLUTION_PAPER_1,
    response,
  };
}
export function onTestSolution2(response) {
  return {
    type: types.TEST_SOLUTION_PAPER_2,
    response,
  };
}
export function onTestOMR1(response) {
  return {
    type: types.TEST_OMR_1,
    response,
  };
}
export function onTestOMR2(response) {
  return {
    type: types.TEST_OMR_2,
    response,
  };
}

export const fetchPerformanceRecord = async (jwtToken, dispatch) => {
  const body = {};
  const url = 'api/studenttestrecord';
  await fetchPost(url, body, jwtToken)
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      if (data.error) {
        return dispatch(
          openSnackBar({
            message: data.message || 'Some error occurred',
            severity: 'error',
          })
        );
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning',
          })
        );
        dispatch(loginActions.logOut());
      }
      dispatch(onPerformanceRecord(data));
    });
};

export const fetchTestResult = async (jwtToken, testID, dispatch) => {
  const body = {
    TestID: testID,
  };
  const url = 'api/gettestresult';
  await fetchPost(url, body, jwtToken)
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      if (data.error) {
        return dispatch(
          openSnackBar({
            message: data.message || 'Some error occurred',
            severity: 'error',
          })
        );
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning',
          })
        );
        dispatch(loginActions.logOut());
      }
      dispatch(onTestResult(data));
    });
};

export const fetchTestAnswerKey = async (jwtToken, testID, dispatch) => {
  for (let i = 1; i < 3; i++) {
    let body = {
      TestID: testID,
      PaperNo: i,
    };
    const url = 'api/GetTestAnswerKey';
    await fetchPost(url, body, jwtToken)
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.error) {
          return dispatch(
            openSnackBar({
              message: data.message || 'Some error occurred',
              severity: 'error',
            })
          );
        }
        if (!get(data, 'IsLoggedIn', true)) {
          dispatch(
            openSnackBar({
              message:
                'Multiple logins detected, please login again to continue',
              severity: 'warning',
            })
          );
          dispatch(loginActions.logOut());
        }
        if (i === 1) dispatch(onTestAnalysis1(data));
        else dispatch(onTestAnalysis2(data));
      });
  }
};

export const fetchTestSolution = async (jwtToken, testID, dispatch) => {
  for (let i = 1; i < 3; i++) {
    let body = {
      TestID: testID,
      PaperNo: i,
    };
    const url = 'api/GetTestSolution';
    await fetchPost(url, body, jwtToken)
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.error) {
          return dispatch(
            openSnackBar({
              message: data.message || 'Some error occurred',
              severity: 'error',
            })
          );
        }
        if (!get(data, 'IsLoggedIn', true)) {
          dispatch(
            openSnackBar({
              message:
                'Multiple logins detected, please login again to continue',
              severity: 'warning',
            })
          );
          dispatch(loginActions.logOut());
        }
        if (i === 1) dispatch(onTestSolution1(data));
        else dispatch(onTestSolution2(data));
      });
  }
};

export const fetchTestOMR = async (jwtToken, testID, dispatch) => {
  for (let i = 1; i < 3; i++) {
    let body = {
      TestID: testID,
      PaperNo: i,
    };

    const url = 'api/GetTestOMR';
    await fetchPost(url, body, jwtToken)
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.error) {
          return dispatch(
            openSnackBar({
              message: data.message || 'Some error occurred',
              severity: 'error',
            })
          );
        }
        if (!get(data, 'IsLoggedIn', true)) {
          dispatch(
            openSnackBar({
              message:
                'Multiple logins detected, please login again to continue',
              severity: 'warning',
            })
          );
          dispatch(loginActions.logOut());
        }
        if (i === 1) dispatch(onTestOMR1(data));
        else dispatch(onTestOMR2(data));
      });
  }
};
